module.exports = __webpack_public_path__ + "static/media/Alex.6a23d9b1.png";